import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addAft } from "../../redux/actions/aftAction";
import regex from "../../utils/regex";
import { useStyles } from "./styles";
import { formFileds } from "./utils";

const ManageAFT = ({ onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { orgUnits, allAftAccountNames } = useSelector((state) => state.aft);
  const [state, setState] = useState({
    accountName: "",
    accountEmail: "",
    ouName: "",
    ssoEmail: "",
    ssoFirstName: "",
    ssoLastName: "",
    type: "",
    budget: "",
    budgetNotificationRecipients: "",
    cloudCustodian: "disabled",
  });
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState({
    ssoEmail: "",
    accountName: "",
    budget: false,
  });

  useEffect(() => {
    let nameExists = "",
      isSSOEmailValid = true,
      budgetExeeds = false;

    const isValidForm = formFileds.every((field) =>
      field.name === "cloudCustodian" ? true : state[field.name]
    );
    if (state?.ssoEmail) {
      isSSOEmailValid = regex.validEmail.test(state?.ssoEmail);
    }
    if (state.accountName) {
      nameExists = allAftAccountNames.find(
        (name) => name === state.accountName
      );
    }
    if (state.budget && state.budget > 100) {
      budgetExeeds = true;
    }
    setError({
      ssoEmail: isSSOEmailValid ? "" : "Invalid email",
      accountName: nameExists ? "Account name already exists!" : "",
      budget:
        budgetExeeds &&
        "Please note that if the budget exceeds $100, supervisor approval is required for account creation",
    });
    setIsValid(isValidForm && isSSOEmailValid && !Boolean(nameExists));
    //eslint-disable-next-line
  }, [state]);

  const handleChange = (key, value) => {
    const updatedValue = key === "budget" ? Number(value) : value;
    if (key === "accountName") {
      setState((prevState) => ({
        ...prevState,
        accountEmail: value ? `aws_root+${value}@altimetrik.com` : "",
      }));
    }

    setState((prevState) => ({
      ...prevState,
      [key]:
        key === "cloudCustodian"
          ? value
            ? "enabled"
            : "disabled"
          : updatedValue,
    }));
  };

  const onBtnClick = () => {
    let payload = { customFields: {} };

    // eslint-disable-next-line
    formFileds.map((field) => {
      if (field?.isCustom) {
        payload.customFields[field?.name] = state[field?.name];
      } else {
        payload[field?.name] = state[field?.name];
      }
    });
    dispatch(addAft(payload));
    onClose();
  };

  return (
    <Box variant="form">
      <Grid container spacing={2}>
        {formFileds.map((data) => {
          return (
            <Grid
              key={data.name}
              item
              xs={12}
              sm={data.gridSize}
              md={data.gridSize}
            >
              {data.name === "cloudCustodian" ? (
                <FormControlLabel
                  variant="outlined"
                  control={
                    <Checkbox
                      onChange={(e) =>
                        handleChange(data.name, e.target.checked)
                      }
                    />
                  }
                  label={data.label}
                />
              ) : data.type === "select" ? (
                <Autocomplete
                  fullWidth
                  options={
                    data.name === "ouName"
                      ? orgUnits
                      : ["Prod", "Non-Prod", "Sandbox"]
                  }
                  defaultValue={state[data.name]}
                  value={state[data.name]}
                  getOptionLabel={(option) => option}
                  onChange={(e, value) => {
                    handleChange(data.name, value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} margin="normal" label={data.label} />
                  )}
                />
              ) : (
                <TextField
                  {...data}
                  fullWidth
                  required
                  type={data.type || "text"}
                  placeholder={data.placeholder || ""}
                  margin="normal"
                  error={Boolean(error?.[data?.name])}
                  helperText={error?.[data?.name]}
                  value={state[data.name]}
                  onChange={(e) => handleChange(data.name, e.target.value)}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      <Box className={classes.footer}>
        <Button disabled={!isValid} variant="contained" onClick={onBtnClick}>
          Add New Account
        </Button>
      </Box>
    </Box>
  );
};

export default ManageAFT;
